import React, { useRef } from "react";
import BannerSection from "./BannerSection";
import StatsSection from "./Stats";
import WeDeliver from "./WeDeliver";
import SetApartSection from "./SetApartSection";
import ExtraPerformanceAdvice from "./ExtraPerformanceAdvice";
import TeamGoal from "./TeamGoal";
import CalendlySection from "./CalendlySection";
import Disclaimer from "./Disclaimer";
import { useLocation } from "react-router-dom";
import Fullpage from "../../../components/Layout/Fullpage";
import HideFooter from "../../../components/HideFooter";
import HideHeader from "../../../components/HideHeader";
import FeaturedIn from "../../../components/HTML/FeaturedIn";
import CommonCalendlySection from "../common/CommonCalendlySection";
import VideosSection from "../../../components/HTML/VideosSection";

const FinancialPlanningPageCalendly = () => {

    const location = useLocation();

    const landingPageLocation = location.pathname;

    const getCalendlyUrl = (currLocation) => {
        return "https://calendly.com/fintoo/dummy-for-it"
        // const normalizedPath = currLocation.replace(/\/$/, '');
        // switch (normalizedPath) {
        //     case '/web/financial-planning/':
        //         return "https://calendly.com/d/4j9-7sh-yry/15-minutes-consultation-call?embed_domain=www.fintoo.in&embed_type=Inline&hide_event_type_details=1&month=2025-05"
        //     default:
        //         return "https://calendly.com/d/4j9-7sh-yry/15-minutes-consultation-call?embed_domain=www.fintoo.in&embed_type=Inline&hide_event_type_details=1&month=2025-05"
        // }
    }

    const targetRef = useRef(null);
    const targetRef2 = useRef(null);

    const scrollToForm = () => {
        webengage.track("book complimentary session clicked", {
            "cta name": window.location.href ?? ''
        });

        if (targetRef.current) {
            targetRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    const scrollToNextSection = () => {
        if (targetRef2.current) {
            targetRef2.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    return (
        <Fullpage>
            <HideFooter />
            <HideHeader />
            <BannerSection scrollToForm={scrollToForm} scrollToNextSection={scrollToNextSection} />
            <section ref={targetRef2}>
                <FeaturedIn />
            </section>
            <WeDeliver />
            <SetApartSection />
            <ExtraPerformanceAdvice />
            <StatsSection />
            <VideosSection />
            <TeamGoal />
            <section ref={targetRef} >
                <CommonCalendlySection isWP={true} extraPamamsObj={{ service: "100", plan_name: 'Assisted Advisory (Fixed Fees)' }} calendlyUrl={getCalendlyUrl(landingPageLocation)} />
            </section>
            <Disclaimer />
        </Fullpage>
    );
}

export default FinancialPlanningPageCalendly;
